import styled from 'astroturf/react';

const ColumnIconArrow = styled('div')`
  border: solid var(--white);
  border-width: 0 2px 2px 0;
  padding: 3px;
  transform: rotate(45deg);
  margin: -10px 5px 0 10px;
  display: inline-block;
  width: 0;
  position: relative;
  top: -3px;
`;

const ColumnArrow = styled('span')`
  margin-left: 5px;
  color: var(--white);
`;

export default {
  ColumnIconArrow,
  ColumnArrow,
};
